import { useState } from 'react';
import Header from "@arelia-components/layout/Header";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import { TwilioMonitorPresenter } from "./TwilioMonitorPresenter";
import { useTwilioMonitor, useActiveSessions } from "./api";

export function TwilioMonitorContainer() {
  const [searchValue, setSearchValue] = useState('');
  const { data: records = [], isLoading: isLoadingRecords } = useTwilioMonitor();
  const { data: sessions, isLoading: isLoadingSessions } = useActiveSessions();


  return (
    <ContentBox>
      <Header title="Twilio Registration Monitor" />
      <TwilioMonitorPresenter
        searchValue={searchValue}
        setSearchValue={(value) => setSearchValue(value)}
        records={records}
        isLoadingRecords={isLoadingRecords}
        sessions={sessions}
        isLoadingSessions={isLoadingSessions}
      />
    </ContentBox>
  );
}
